let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    jQuery('.header .hamburger').trigger('click')

})

jQuery(document).on('keydown', function(event) {
    if (event.key == "Escape") {

        if( jQuery('body').hasClass('is-drawer') ){

            if (jQuery('.hamburger-toggle .hamburger').hasClass('is-active')){
                jQuery('.hamburger.hamburger--spin').focus()
                jQuery('.drawer').attr('tabindex', '-1')
            } else{
                jQuery('.drawer').attr('tabindex', '1').focus()
            }

            jQuery('body').toggleClass('is-drawer')
            jQuery('.hamburger').toggleClass('is-active')
            jQuery('.hamburger-toggle .hamburger').attr('tabindex', '0')
        }
    }
});

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    jQuery( '.ticket-popup' ).hide()

    if (jQuery(this).hasClass('is-active')) {
        jQuery('.drawer').attr('tabindex', '-1')
    } else {
        jQuery('.drawer').attr('tabindex', '1').focus()
        // jQuery('.drawer__search button').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

})

jQuery(window).on('scroll', function () {
    if (jQuery(window).scrollTop() > 0) {
        header.addClass('header--white')
    } else {
        header.removeClass('header--white')
    }
})

jQuery('.drawer__nav .toggle').on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        jQuery('.drawer__nav .open').removeClass('open').next().slideToggle()
        parentEl.toggleClass('open').next().slideToggle()
    }

})
